import {AfterViewInit, ChangeDetectorRef, Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-audio-player',
    templateUrl: './audio-player.component.html',
    styleUrl: './audio-player.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AudioPlayerComponent implements AfterViewInit {
    @Input() file: any = null;
    @Input() small: boolean = false;

    maxBars: number = 100;
    width: string = '4px';
    state: string = 'play';
    waveform: any[] = []

    constructor(private readonly cdr: ChangeDetectorRef,) {
    }

    ngAfterViewInit(): void {
        if (this.small || window.innerWidth <= 600) {
            this.maxBars = 40;
            this.width = '2px'
        }
        for (let i = 0; i < this.maxBars; i++) {
            let delay: number = Math.random() * (0.7 - 0.2) + 0.2
            this.waveform.push({delay: delay + 's'})
        }

        setTimeout((): void => {
            this.state = 'paused';
            this.cdr.detectChanges();
        }, 200);
    }

    thumbnailClick(element: HTMLAudioElement, state: string): void {
        if (state == 'play') {
            this.state = 'paused';
            element.pause()
        } else {
            this.state = 'play';
            element.play();
        }
    }
}
